import { useState } from 'react';
import Button from '@component/Button';
import FlexBox from '@component/FlexBox/FlexBox';
import Label from '@component/Label';
import {
  DescriptionModuleFormType,
  OliveYoungOnlyBuyModuleFormType,
} from '@container/Challenge/NewChallengeForm/NewChallengeForm.types';
import { DEFAULT_DATA } from './OliveYoungOnlyBuyModule.constant';
import ProductInfoForm from './components/ProductInfoForm/ProductInfoForm';
import PurchaseRequiredTextListForm from './components/PurchaseRequiredTextListForm/PurchaseRequiredTextListForm';
import ReviewInfoForm from './components/ReviewInfoForm/ReviewInfoForm';
import {
  DescriptionModule,
  DescriptionModuleConvertData2Form,
  DescriptionModuleConvertForm2Data,
} from '../../DescriptionModuleForm.type';
import { validate } from './OliveYoungOnlyBuyModule.validator';
import {
  convertData2Form,
  convertForm2Data,
} from './OliveYoungOnlyBuyModule.serializer';
import AddModuleModal from '../AddModuleModal/AddModuleModal';
import useSubModule from '../../hooks/useSubModule';
import PurchaseCheckTextListForm from './components/PurchaseCheckTextListForm/PurchaseCheckTextListForm';

type OliveYoungOnlyBuyModuleProps = {
  type: 'COLLABO-OLIVEYOUNG-ONLY-BUY';
  data: OliveYoungOnlyBuyModuleFormType;
  moduleIndex: number;
  onUpdate: (index: number, item: DescriptionModuleFormType) => void;
};
const OliveYoungOnlyBuyModule: DescriptionModule<
  OliveYoungOnlyBuyModuleProps
> = (props: OliveYoungOnlyBuyModuleProps) => {
  const { type, data, moduleIndex, onUpdate } = props;

  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const { List: SubModuleList, add: addSubModule } = useSubModule({
    data: data.subModule,
    onChange: (subModuleListData) => {
      onUpdate(moduleIndex, {
        type,
        data: {
          ...data,
          subModule: subModuleListData,
        },
      });
    },
  });

  const showModal = () => setModalVisible(true);
  const hideModal = () => setModalVisible(false);

  const handleChangePurchaseRequiredTextList = (
    purchaseRequiredTextList: OliveYoungOnlyBuyModuleFormType['purchaseRequiredTextList'],
  ) => {
    onUpdate(moduleIndex, {
      type,
      data: {
        ...data,
        purchaseRequiredTextList,
      },
    });
  };

  const handleChangePleaseCheckTextList = (
    pleaseCheckTextList: OliveYoungOnlyBuyModuleFormType['pleaseCheckTextList'],
  ) => {
    onUpdate(moduleIndex, {
      type,
      data: {
        ...data,
        pleaseCheckTextList,
      },
    });
  };

  const handleChange = (updated: Partial<OliveYoungOnlyBuyModuleFormType>) =>
    onUpdate(moduleIndex, {
      type,
      data: {
        ...data,
        ...updated,
      },
    });

  return (
    <FlexBox.Column
      style={{ border: '1px solid black', maxWidth: 720, padding: 12 }}
    >
      <Label>{type}</Label>
      <PurchaseRequiredTextListForm
        data={data.purchaseRequiredTextList}
        onChange={handleChangePurchaseRequiredTextList}
      />
      <hr />
      {SubModuleList}
      <hr />
      <Button
        text="서브 모듈 추가"
        bgColor="black"
        size="large"
        fontColor="white"
        onClick={showModal}
      />
      <hr />
      <ProductInfoForm data={data} onChange={handleChange} />
      <hr />
      <ReviewInfoForm data={data} onChange={handleChange} />
      <hr />
      <PurchaseCheckTextListForm
        data={data.pleaseCheckTextList}
        onChange={handleChangePleaseCheckTextList}
      />
      <AddModuleModal
        isSubModule
        open={modalVisible}
        onClose={hideModal}
        onAdd={addSubModule}
      />
    </FlexBox.Column>
  );
};

export default OliveYoungOnlyBuyModule;

OliveYoungOnlyBuyModule.moduleName = '올영 구매만';
OliveYoungOnlyBuyModule.defaultData = DEFAULT_DATA;
OliveYoungOnlyBuyModule.validate = validate;
OliveYoungOnlyBuyModule.convertForm2Data =
  convertForm2Data as DescriptionModuleConvertForm2Data;
OliveYoungOnlyBuyModule.convertData2Form =
  convertData2Form as DescriptionModuleConvertData2Form;
